import React from 'react';
import ReactDOM from 'react-dom';
import './custom.scss';
import './index.scss';
import './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import SafeProvider from '@gnosis.pm/safe-apps-react-sdk';

serviceWorker.register();

ReactDOM.render(
  <React.StrictMode>
    <SafeProvider>
      <App />
    </SafeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
